import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillGoogleCircle,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am <span className="purple">Kazi Shahriar Sanjid</span>, a <span className="purple">PhD Applicant</span> focused on Algorithms, AI & Systems for Computational Biology. 
              <br />
              <br />I am currently a <span className="purple">Research Assistant</span> at North South University and an <span className="purple">AI Research Engineer</span> at Diagnotech-Ai.
              <br />
              <br />I am proficient in languages like
              <i>
                <b className="purple"> Python, C/C++, and JavaScript. </b>
              </i>
              <br />
              <br />
              My research focuses on developing novel algorithms integrating <span className="purple">State Space Models (Mamba)</span> with hierarchical networks for biomedical segmentation, achieving state-of-the-art accuracy with reduced computational complexity.
              <br />
              <br />
              I have contributed to <span className="purple">5+ publications</span> including 2 Q1 journals, 1 conference, and 2 preprints. I work extensively with deep learning frameworks like <b className="purple">PyTorch</b> and <b className="purple">TensorFlow</b>, specializing in algorithm-hardware co-design, model compression, and multimodal data processing.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Ratim321" // Update with your GitHub link
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
             
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/kazi-shahriar-sanjid-302a031a5/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://scholar.google.com/citations?user=nP85SgUAAAAJ&hl=en"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGoogleCircle />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
